function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(0 0.5)"
},
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(-592.849 -354.5)"
},
/*#__PURE__*/
React.createElement("path", {
  d: "M-5951.866,196.877h-4.39a.881.881,0,0,1-.769-.392.92.92,0,0,1-.021-.9l2.19-4.562v-5.462a6.072,6.072,0,0,1,6.064-6.064,6.072,6.072,0,0,1,6.067,6.064v5.463l2.187,4.56a.916.916,0,0,1-.019.9.879.879,0,0,1-.769.392h-4.39a3.12,3.12,0,0,1-3.077,2.624A3.119,3.119,0,0,1-5951.866,196.877Zm3.075,1.64a2.138,2.138,0,0,0,2.075-1.64h-4.147A2.135,2.135,0,0,0-5948.791,198.517Z",
  transform: "translate(6551.649 175)",
  stroke: "rgba(0,0,0,0)",
  strokeMiterlimit: 10,
  strokeWidth: 1
})),
/*#__PURE__*/
React.createElement("rect", {
  width: 20,
  height: 20,
  transform: "translate(0 0)",
  fill: "none"
}));

var SvgAlertsSelected = function SvgAlertsSelected(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 20,
      height: 20,
      viewBox: "0 0 20 20",
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2)
  );
};

var ForwardRef =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React.createElement(SvgAlertsSelected, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/AlertsSelected.9befeeb1.svg";
export { ForwardRef as ReactComponent };